export class ClassificationSystem {

  constructor(
    public id?: string,
    public name?: string,
    public language?: string,
    public date?: Date,
    public version?: number,
    public isGlobal?: boolean,
    public createdByCustomerId?: string,
    public createdByUserName?:string,
    public requiredAddon?: string
  ) {
  }
}
